import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { usePriceFormatter } from '~/hooks/usePriceFormatter';
import type { ProductViewProps } from '~/pages/Product/Product';
import { Offer } from '~/stores/CategoriesStore/Offer';

import { ProductDEMultibuyLevels } from './ProductDEMultibuyLevels';
import { ProductDEPriceHeadline } from './ProductDEPriceHeadline';

type Props = Pick<
  ProductViewProps,
  'isMultiBuy' | 'currentPrice' | 'currentItem' | 'count'
> & {
  isLoading?: boolean;
};

/**
 * Price block of the mobile product page, under the title and trust chips:
 * the price line, the quantity price levels and the customs duty. The CTA
 * stays in the bottom bar.
 */
const ProductDEMobilePriceView = ({
  isMultiBuy,
  currentPrice,
  currentItem,
  count,
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  const formatPrice = usePriceFormatter();

  const customsFee =
    company.showProductCustomsInfo && currentItem instanceof Offer
      ? currentItem.customsFee
      : null;

  return (
    <div className="mt-5 flex flex-col gap-2.5">
      <ProductDEPriceHeadline
        isMultiBuy={isMultiBuy}
        currentPrice={currentPrice}
        currentItem={currentItem}
        isLoading={isLoading}
        variant="inline"
      />
      <ProductDEMultibuyLevels
        isMultiBuy={isMultiBuy}
        currentItem={currentItem}
        count={count}
        isLoading={isLoading}
      />
      {!isLoading && !!customsFee && (
        <div className="flex items-baseline gap-2 text-[14px] leading-5">
          <span className="text-[#8A8A8A]">{t('customsDutiesFee')}</span>
          <span className="font-medium text-[#141415]">
            {formatPrice(customsFee / 100)}
          </span>
        </div>
      )}
    </div>
  );
};

export const ProductDEMobilePrice = observer(ProductDEMobilePriceView);
